import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { authMe, authSession, authLogout } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const u = await authMe();
      setUser(u);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: skip /me check if returning from OAuth (callback handles it)
    if (typeof window !== 'undefined' && window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  // Exchange session_id for cookie session
  const completeGoogleLogin = async (sessionId) => {
    const ref = typeof window !== 'undefined' ? localStorage.getItem('cs_ref') : null;
    const { user: u } = await authSession(sessionId, ref);
    if (ref) localStorage.removeItem('cs_ref');
    setUser(u);
    return u;
  };

  const startGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/app';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try { await authLogout(); } catch (e) { /* ignore */ }
    setUser(null);
    localStorage.removeItem('cs_meals');
  };

  return (
    <AuthContext.Provider value={{ user, loading, startGoogleLogin, completeGoogleLogin, logout, refresh: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
